import React from 'react';
import { Helmet } from 'react-helmet-async';
import Container from '../components/layout/Container';
import SectionTitle from '../components/ui/SectionTitle';
import CTASection from '../components/ui/CTASection';

const ContactPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | IDX.rainautomation.com</title>
        <meta
          name="description"
          content="Have questions about IDX, pricing, or setup? Contact our team and get the help you need to elevate your real estate brand."
        />
        <link rel="canonical" href="https://idx.rainautomation.com/contact" />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us - rAIn IDX",
            "description": "Get in touch with the rAIn Automation team for questions about IDX integration, partnerships, or customer support.",
            "url": "https://idx.rainautomation.com/contact"
          }
          `}
          </script>
      </Helmet>

      <section className="pt-32 pb-16">
        <Container>
          <SectionTitle
            title="Let’s Connect"
            subtitle="Questions? Feedback? We’re here to help."
            centered
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-12">
            <div>
              <h2 className="text-2xl font-semibold mb-4">Our Support Team</h2>
              <p className="text-neutral-700 mb-6">
                Whether you're just getting started or looking to switch IDX providers, our team is ready to assist. We aim to respond within one business day.
              </p>
              <ul className="text-neutral-700 space-y-2">
                <li><strong>Email:</strong> support@rainautomation.com</li>
                <li><strong>Phone:</strong> (555) 123-4567</li>
                <li><strong>Office Hours:</strong> Mon–Fri, 9am–5pm EST</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4">Send a Message</h2>
              <form className="space-y-4">
                <div>
                  <label htmlFor="name" className="block mb-1 font-medium">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full border border-neutral-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block mb-1 font-medium">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full border border-neutral-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block mb-1 font-medium">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    className="w-full border border-neutral-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                  />
                </div>

                <button
                  type="submit"
                  className="bg-primary-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-primary-700 transition"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </Container>
      </section>

      <CTASection
        title="Ready to elevate your brand?"
        subtitle="Join thousands of real estate professionals using IDX.rainautomation.com"
        primaryButtonText="Get Started"
        secondaryButtonText="See Features"
        primaryButtonTo="/contact"
        secondaryButtonTo="/features"
        background="light"
      />
    </>
  );
};

export default ContactPage;